import { withAsyncLoading } from '../../lib/PST.Web.Common/src/hocs/withAsyncPageLoading/withAsyncPageLoading';

const LoadableFormationDetailPage = withAsyncLoading(async () => import('./FormationDetailPage').then((res) => res.FormationDetailPage));

export { LoadableFormationDetailPage };
